module.exports = __webpack_public_path__ + "media/images/emoticons/karaoke-ebfc0e75e105722c6b28107af7c106bc.gif";